import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';

export interface Roadmap {
  id: number;
  description: string;
  startDate: string;
  endDate: string;
  groups: RoadmapGroup[];
}

export interface RoadmapGroup {
  id: number;
  title: string;
  colour: string;
  items: RoadmapItem[];
}

export interface RoadmapItem {
  id: number;
  group: number;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
}

export class RoadmapService extends AuthenticatedService {
  public list = async (): Promise<IHttpResponse<Roadmap[]>> => {
    const roadmaps = await this.getAuth<Roadmap[]>(
      'roadmaps',
    );

    return roadmaps;
  }

  public byId = async (id: number): Promise<IHttpResponse<Roadmap>> => {
    const roadmap = await this.getAuth<Roadmap>(
      `roadmaps/${id}`,
    );

    return roadmap;
  }

  public create = async (roadmap: Roadmap): Promise<IHttpResponse<Roadmap>> => {
    const newRoadmap = await this.postAuth<Roadmap>(
      'roadmaps', roadmap,
    );

    return newRoadmap;
  }

  public update = async (roadmap: Roadmap): Promise<IHttpResponse<Roadmap>> => {
    const newRoadmap = await this.putAuth<Roadmap>(
      `roadmaps/${roadmap.id}`, roadmap,
    );

    return newRoadmap;
  }

  public remove = async (id: number): Promise<IHttpResponse<Roadmap>> => {
    const newRoadmap = await this.deleteAuth<Roadmap>(
      `roadmaps/${id}`,
    );

    return newRoadmap;
  }
}
